import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import DocumentManagement from './pages/DocumentManagement';
import DocumentView from './pages/DocumentView';
import GuidelinesManagement from './pages/GuidelinesManagement';
import GuidelineView from './pages/GuidelineView';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Navigate to="/documents" replace />} />
            <Route path="/documents" element={<DocumentManagement />} />
            <Route path="/document_view/:id" element={<DocumentView />} />
            <Route path="/guidelines" element={<GuidelinesManagement />} />
            <Route path="/guideline_view/:id" element={<GuidelineView />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;

